var render = function render(){var _vm=this,_c=_vm._self._c;return _c('distributor-form',{ref:"form",staticClass:"distributor-info",attrs:{"formKey":_vm.formKey,"action":_vm.action,"avatarColumnMode":true,"distributorId":_vm.distributorId,"method":_vm.method,"hide-notification-settings":""},on:{"submitSuccess":_vm.onSubmitSuccess,"formValid":_vm.isFormValid}})
}
var staticRenderFns = []

export { render, staticRenderFns }